import copy from "../../../copy/en/documents-consolidated.json" with { type: "json" };
import { lazy } from "react";
import { Outlet, useLocation } from "react-router";
import { useMe } from "../../auth/MeProvider.js";
import { DocumentsNavigation, documentsSection } from "./DocumentsNavigation.js";
export { documentsSection } from "./DocumentsNavigation.js";
const AdminDocumentRequirementsPage = lazy(async () => ({ default: (await import("../document-updates/AdminDocumentRequirementsPage.js")).AdminDocumentRequirementsPage }));
const DocumentsPage = lazy(async () => ({ default: (await import("./workflow/DocumentsPage.js")).DocumentsPage }));

export function DocumentsLayout() {
  return <><DocumentsNavigation /><Outlet /></>;
}
export function ConsolidatedDocumentsPage() {
  const { me, hasCap } = useMe(), location = useLocation();
  const section = documentsSection(location.pathname, location.search, me?.role === "admin" && !me.viewAs);
  if (section === "representatives") return <AdminDocumentRequirementsPage />;
  if (section === "history" && hasCap("view:all")) return <p className="muted">{copy.historyDescription}</p>;
  return <DocumentsPage />;
}
